function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import JSURL from 'jsurl';
import { ReportName } from 'common/report/constants';
import { ReportHeader, ReportHeaderJsxProps } from 'common/report/report-manager/report-header';
import { SearchDisplayContext } from 'common/report/util/search/types';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { FlowsBookmark } from 'common/report/flows/models/types';
import { FlowsResponse } from 'common/report/funnels/models/api-types';
import { FlowsReport } from 'common/report/flows/models/report';
export class FlowsReportHeader extends ReportHeader<FlowsBookmark, FlowsResponse> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "displayContext", SearchDisplayContext.Flows);
    _defineProperty(this, "reportType", ReportName.Flows);
    _defineProperty(this, "customAlertsEnabled", false);
    _defineProperty(this, "csvExportEnabled", false);
  }
  getInvalidParamsMessage(): string {
    if (!this.bookmark.params.steps.filter(step => (step === null || step === void 0 ? void 0 : step.event) !== null).length) {
      return "Please select an event to save your flows report";
    }
    return null;
  }
  getStandaloneHash(titleOverride?: string) {
    const report = FlowsReport.fromBookmarkParams(this.bookmark.params);
    if (titleOverride) {
      report.name = titleOverride;
    }
    return JSURL.stringify(report.toUrlData());
  }
}
export const FlowsReportHeaderEl = defineAndMakeJsxFactory<ReportHeaderJsxProps>("flows-report-header", FlowsReportHeader);
export const FlowsReportHeaderReact = panel2react<ReportHeaderJsxProps>("flows-report-header", FlowsReportHeader);